import {HttpRequestType, NetworkProtocol} from "../_types";

type returnType = 'json' | 'text' | 'none';

export type HttpRequest = {
    method: HttpRequestType
    headers: any
    body?: any,
}

export type UriOptions = {
    type?: NetworkProtocol;
    address?: string;
    port?: number;
    route?: string;
}

function requestOptions(type: HttpRequestType, data: any = null, headers?: Object): HttpRequest {
    const options: HttpRequest = {
        method: type,
        headers: {...headers}
    };

    if (data) {
        if (!options.headers.hasOwnProperty('Content-Type') || options.headers['Content-Type'] === 'application/json') {
            options.headers['Content-Type'] = 'application/json';
            options.body = JSON.stringify(data);
        } else
            options.body = data;
    }

    return options;
}

async function responseHandler(response: any, returnType: string = 'json') {
    if (response.ok) {
        if (returnType !== 'none') {
            if (returnType === 'json')
                return await response.json();
            else if (returnType === 'text')
                return await response.text();
        } else {
            return true;
        }
    }

    let error: string = '';
    try {
        error = (await response.json()).error;
    } catch (e) {
        error = e;
    }

    return Promise.reject(error);
}

const createUri = (options: UriOptions) => {
    const type: NetworkProtocol = options.type || NetworkProtocol.Http;
    const address: string = options.address || process.env.address || 'localhost';
    const port: number = options.port || 80;
    const route: string = options.route || '/';
    return `${type}://${address}:${port}${route}`;
};

const get = async (uri: string, returnType: returnType = 'json', additionalHeaders?: Object): Promise<any> => {
    const options = requestOptions(HttpRequestType.Get, null, additionalHeaders);
    const response = await fetch(uri, options);
    return await responseHandler(response, returnType);
};

const post = async (uri: string, data: any, returnType: returnType = 'json', additionalHeaders?: Object) => {
    const opt = requestOptions(HttpRequestType.Post, data, additionalHeaders);
    const response = await fetch(uri, {...opt});
    return await responseHandler(response, returnType);
};

const put = async (uri: string, data: any, returnType: returnType = 'json', additionalHeaders?: Object) => {
    const options = requestOptions(HttpRequestType.Put, data, additionalHeaders);
    const response = await fetch(uri, options);
    return await responseHandler(response, returnType);
};

const _delete = async (uri: string, data: any = null, returnType: returnType = 'json', additionalHeaders?: Object) => {
    const options = requestOptions(HttpRequestType.Delete, data, additionalHeaders);
    const response = await fetch(uri, options);
    return await responseHandler(response, returnType);
};

export default {
    get,
    post,
    put,
    delete: _delete,
    requestOptions,
    responseHandler,
    createUri
}
